export default {"src":"/_next/static/media/brand-popeyes-logo.f8879df9.svg","height":54,"width":212,"blurWidth":0,"blurHeight":0};